/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./footer.css";
import { FaFacebookF } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { IoLogoTwitter } from "react-icons/io";

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">
        SHAMSUL AREFIN
      </a>

      <ul className="permalinks">
        <li>
          <a href="#" className="permalinks__color">Home</a>
        </li>
        <li>
          <a href="#about" className="permalinks__color">About</a>
        </li>
        <li>
          <a href="#experience" className="permalinks__color">Experience</a>
        </li>
        <li>
          <a href="#services" className="permalinks__color">Services</a>
        </li>
        <li>
          <a href="#portfolio" className="permalinks__color">Portfolio</a>
        </li>
        <li>
          <a href="#testimonials" className="permalinks__color">Testimonials</a>
        </li>
        <li>
          <a href="#contact" className="permalinks__color">Contact</a>
        </li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.facebook.com/shamsul.arefin.925059">
          <FaFacebookF />
        </a>
        <a href="https://www.instagram.com/_shams_arefin_/">
          <FiInstagram />
        </a>
        <a href="https://twitter.com/arefins56">
          <IoLogoTwitter />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Md. Shamsul Arefin. All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
